<main class="verification-page">
  <section *ngIf="data?.loading" class="verification-card loading-card" aria-live="polite">
    <div class="loading-spinner" aria-hidden="true"></div>
    <h1>Gerando QR Code de validação</h1>
    <p>Estamos preparando o QR Code para validar o cadastro Pagar.me. Isso pode levar alguns instantes.</p>
    <p>Você pode aguardar nesta tela; ela será atualizada automaticamente assim que o código estiver disponível.</p>
  </section>

  <section *ngIf="!data?.loading && verificationData; else noVerificationData" class="verification-card">
    <header class="page-header">
      <div class="header-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path
            d="M7 3H5a2 2 0 0 0-2 2v2m14-4h2a2 2 0 0 1 2 2v2M7 21H5a2 2 0 0 1-2-2v-2m14 4h2a2 2 0 0 0 2-2v-2M8 8h3v3H8V8Zm5 0h3v3h-3V8Zm-5 5h3v3H8v-3Zm5 0h1v1h-1v-1Zm2 0h1v3h-3v-1h2v-2Z"
          />
        </svg>
      </div>

      <div>
        <h1>Verificação de identidade</h1>
        <p>Escaneie o QR Code ou copie o link para iniciar a verificação.</p>
      </div>
    </header>

    <div class="status" [class.status-active]="!expired" [class.status-expired]="expired">
      <span class="status-dot"></span>
      {{ expired ? 'Link expirado' : 'Link disponível' }}
    </div>

    <section class="qr-code-section">
      <div class="qr-code-container" [class.qr-code-expired]="expired">
        <img [src]="qrCodeUrl" alt="QR Code para verificação de identidade" />

        <div *ngIf="expired" class="expired-overlay">
          <span>Expirado</span>
        </div>
      </div>

      <p class="qr-instruction">Aponte a câmera do celular para o QR Code</p>
    </section>

    <section class="information-section">
      <div class="field-group">
        <label for="verification-url">Link da verificação</label>

        <div class="url-field">
          <input id="verification-url" type="text" [value]="verificationData.url" readonly />

          <button type="button" class="copy-button" [class.copy-button-success]="copied" [disabled]="expired" (click)="copyUrl()">
            <svg *ngIf="!copied" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M8 7V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2M5 8h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Z"
              />
            </svg>

            <svg *ngIf="copied" viewBox="0 0 24 24" aria-hidden="true">
              <path d="m5 12 4 4L19 6" />
            </svg>

            {{ copied ? 'Copiado' : 'Copiar URL' }}
          </button>
        </div>

        <p *ngIf="copied" class="copy-feedback" aria-live="polite">Link copiado para a área de transferência.</p>
      </div>

      <div class="expiration-card">
        <div class="expiration-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 8v5l3 2M5 3v3m14-3v3M4 9h16M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
          </svg>
        </div>

        <div class="expiration-information">
          <span class="expiration-label">Data de expiração</span>
          <strong>{{ expirationText }}</strong>

          <span class="remaining-time" [class.remaining-time-expired]="expired">
            {{ expired ? 'Este link não pode mais ser utilizado.' : 'Tempo restante: ' + remainingTime }}
          </span>
        </div>
      </div>

      <a
        class="open-link-button"
        [class.open-link-disabled]="expired"
        [href]="expired ? null : verificationData.url"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-disabled]="expired"
        [attr.tabindex]="expired ? -1 : 0"
      >
        Abrir página de verificação

        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14 5h5v5m0-5-9 9M19 14v5H5V5h5" />
        </svg>
      </a>
    </section>

    <footer>Por segurança, o QR Code e o link deixarão de funcionar após a data de expiração.</footer>
  </section>

  <ng-template #noVerificationData>
    <section *ngIf="!data?.loading" class="verification-card empty-state">
      <div class="empty-state-icon">!</div>
      <h1>Dados não encontrados</h1>
      <p>Não foi possível carregar os dados da verificação de identidade.</p>
    </section>
  </ng-template>
</main>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>
